import { Helmet } from "react-helmet-async";
import { StandalonePage, StandalonePanel } from "@/components/marketing/StandalonePage";

/**
 * What a public organization page shows when its lookup FAILED (issue #1063),
 * as opposed to resolving to nothing. A failed read is not "not found": the
 * page may well exist, so this says so, offers a retry, and carries NO
 * `robots` meta — a transient outage must never noindex a live page. Only a
 * resolved null renders the page's NotFound (with `noindex`).
 */
const PublicLoadError = ({
  title,
  onRetry,
  retrying,
}: {
  /** The tab title, without the " | Compaire" suffix. */
  title: string;
  onRetry: () => void;
  retrying: boolean;
}) => (
  <StandalonePage>
    <Helmet>
      <title>{`${title} | Compaire`}</title>
    </Helmet>
    <StandalonePanel
      tone="error"
      title="Something went wrong"
      actions={
        <button
          type="button"
          className="mk-btn mk-btn--primary"
          onClick={onRetry}
          disabled={retrying}
          aria-busy={retrying || undefined}
        >
          {retrying ? "Trying again…" : "Try again"}
        </button>
      }
    >
      <p className="mk-body">We couldn't load this page right now.</p>
    </StandalonePanel>
  </StandalonePage>
);

export default PublicLoadError;
